// source: pbtypes/gen/telit_lte_modem/cellular_modem_states.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_telit_lte_modem_cellular_modem_state_pb = require('../../../pbtypes/gen/telit_lte_modem/cellular_modem_state_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_cellular_modem_state_pb);
goog.exportSymbol('proto.telit_lte_modem.CellularModemStates', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telit_lte_modem.CellularModemStates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.telit_lte_modem.CellularModemStates.repeatedFields_, null);
};
goog.inherits(proto.telit_lte_modem.CellularModemStates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telit_lte_modem.CellularModemStates.displayName = 'proto.telit_lte_modem.CellularModemStates';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.telit_lte_modem.CellularModemStates.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telit_lte_modem.CellularModemStates.prototype.toObject = function(opt_includeInstance) {
  return proto.telit_lte_modem.CellularModemStates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telit_lte_modem.CellularModemStates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularModemStates.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
statesList: jspb.Message.toObjectList(msg.getStatesList(),
    pbtypes_gen_telit_lte_modem_cellular_modem_state_pb.CellularModemState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telit_lte_modem.CellularModemStates}
 */
proto.telit_lte_modem.CellularModemStates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telit_lte_modem.CellularModemStates;
  return proto.telit_lte_modem.CellularModemStates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telit_lte_modem.CellularModemStates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telit_lte_modem.CellularModemStates}
 */
proto.telit_lte_modem.CellularModemStates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new pbtypes_gen_telit_lte_modem_cellular_modem_state_pb.CellularModemState;
      reader.readMessage(value,pbtypes_gen_telit_lte_modem_cellular_modem_state_pb.CellularModemState.deserializeBinaryFromReader);
      msg.addStates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telit_lte_modem.CellularModemStates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telit_lte_modem.CellularModemStates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telit_lte_modem.CellularModemStates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularModemStates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_telit_lte_modem_cellular_modem_state_pb.CellularModemState.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemStates.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemStates} returns this
 */
proto.telit_lte_modem.CellularModemStates.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated CellularModemState states = 2;
 * @return {!Array<!proto.telit_lte_modem.CellularModemState>}
 */
proto.telit_lte_modem.CellularModemStates.prototype.getStatesList = function() {
  return /** @type{!Array<!proto.telit_lte_modem.CellularModemState>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_telit_lte_modem_cellular_modem_state_pb.CellularModemState, 2));
};


/**
 * @param {!Array<!proto.telit_lte_modem.CellularModemState>} value
 * @return {!proto.telit_lte_modem.CellularModemStates} returns this
*/
proto.telit_lte_modem.CellularModemStates.prototype.setStatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.telit_lte_modem.CellularModemState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telit_lte_modem.CellularModemState}
 */
proto.telit_lte_modem.CellularModemStates.prototype.addStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.telit_lte_modem.CellularModemState, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telit_lte_modem.CellularModemStates} returns this
 */
proto.telit_lte_modem.CellularModemStates.prototype.clearStatesList = function() {
  return this.setStatesList([]);
};


goog.object.extend(exports, proto.telit_lte_modem);
